import { DEVICE_ROLES } from '@/features/core/container';
import { MetricResolutionAggregator, MetricResolutionTimeSource, SpotRole } from '@/types/iot-portal';
import { option } from '@/util/container';
import { component } from '../component';
import lg from './general-meter-electricity-meter-digital-lg.svg';
import md from './general-meter-electricity-meter-digital-md.svg';
import sm from './general-meter-electricity-meter-digital-sm.svg';

export default option(DEVICE_ROLES, async () => ({
  name: SpotRole.GENERAL_METER_ELECTRICITY_METER_DIGITAL,
  label: 'Allgemeinzähler Stromzähler (digital)',
  shortLabel: 'ALLSTROM(D)',
  icons: { sm, md, lg },
  component: component('general-meter-electricity-meter-digital/GeneralMeterElectricityMeterDigitalDevicePanel.vue'),
  aggregationWidget: {
    enabled: true,
    component: component(
      'general-meter-electricity-meter-digital/GeneralMeterElectricityMeterDigitalAggregationWidget.vue',
    ),
  },
  defaultMetricNames: ['currentEnergy', 'receivedEnergy', 'currentSummationDelivered'],
  importantMetricNames: ['currentEnergy', 'receivedEnergy', 'currentSummationDelivered'],
  aggregationMetricNames: [
    {
      name: 'currentEnergy',
      aggregators: [MetricResolutionAggregator.MEAN],
      timeSource: MetricResolutionTimeSource.START,
    },
    {
      name: 'receivedEnergy',
      aggregators: [MetricResolutionAggregator.MEAN],
      timeSource: MetricResolutionTimeSource.START,
    },
    {
      name: 'currentSummationDelivered',
      aggregators: [MetricResolutionAggregator.MEAN],
      timeSource: MetricResolutionTimeSource.START,
    },
  ],
  consumption: true,
}));
